import styled from 'styled-components';

import { breakpoints, Col, SkeletonElement } from '@notino/react-styleguide-v20';

const BaseCol = styled(Col)`
  padding: 0;
  display: flex;
  justify-content: flex-start;
`;

// CheckBox section
export const StyledCheckBoxCol = styled(BaseCol)`
  @media (min-width: ${breakpoints.md}) {
    justify-content: flex-end;
  }
`;

// Description section
export const StyledDescriptionCol = styled(BaseCol)`
  flex-direction: column;
  padding-left: 1rem;
`;

export const StyledDescriptionSkeleton = styled(SkeletonElement)`
  height: 1rem;

  @media (min-width: ${breakpoints.md}) {
    width: 26.6875rem;
    padding: 0;
  }
`;

export const StyledTitleSkeleton = styled(StyledDescriptionSkeleton)`
  margin-bottom: 0.5rem;
`;

// Button Section
export const StyledButtonCol = styled(BaseCol)`
  align-items: center;
  padding-left: 1rem;

  @media (min-width: ${breakpoints.md}) {
    justify-content: flex-end;
    padding-left: 0;
  }
`;

export const StyledSmallBar = styled(SkeletonElement)`
  margin-top: 0.5rem;
  width: 3.4375rem;
  height: 1rem;

  @media (min-width: ${breakpoints.md}) {
    margin-top: 0;
  }
`;

// Shadow Col for mobile
export const StyledShadowColumn = styled(BaseCol)`
  padding-left: 0.5rem;

  @media (min-width: ${breakpoints.md}) {
    display: none;
  }
`;
